import { StatsigProvider, useClientAsyncInit } from '@statsig/react-bindings';
import { ReactNode } from 'react';

import { useAuth } from '@/state/auth';

// StatsigWrapper provides feature flag context using user authentication
function StatsigWrapper({ children }: { children: ReactNode }) {
  const { me, friend } = useAuth();

  // Extract organization domain from email
  const organizationId = me ? me.split('@')[1] || '' : '';

  const statsigUser = {
    userID: me || 'anonymous',
    email: me || '',
    custom: {
      organizationID: organizationId,
      isPraetorian: me ? me.endsWith('@praetorian.com') : false,
      isImpersonating: !!friend,
    },
  };

  const clientKey = import.meta.env.VITE_STATSIG_CLIENT_KEY || '';

  // IMPORTANT: Hook must be called unconditionally (Rules of Hooks)
  // Use async initialization hook to fetch latest feature flag values
  const { client } = useClientAsyncInit(clientKey, statsigUser, {
    loggingEnabled: 'always', // Enable error logs for debugging
    networkConfig: {
      api: 'https://featuregates.org/v1', // Explicit API endpoint
      preventAllNetworkTraffic: false,
      networkTimeoutMs: 5000, // Wait up to 5s for network requests
    },
  });

  // Always wrap in StatsigProvider so child components can safely use hooks like useGateValue
  // The provider will handle the loading state internally
  // When user is not signed in, gates will return false (default) which is the expected behavior
  return <StatsigProvider client={client}>{children}</StatsigProvider>;
}

export default StatsigWrapper;
